<template>
  <div>
    <el-form-item
      :label="t('users.realName')"
      prop="name"
    >
      <el-input
        v-model="formData.name"
        :placeholder="t('errors.pleaseInput', [])"
        maxlength="10"
        show-word-limit
      />
    </el-form-item>

    <el-form-item
      :label="t('users.identityNo')"
      prop="identity_no"
    >
      <el-input
        v-model="formData.identity_no"
        :placeholder="t('errors.pleaseInput', [])"
        maxlength="20"
      />
    </el-form-item>

    <el-form-item
      :label="t('users.birthday')"
      prop="birthday"
    >
      <el-date-picker
        v-model="formData.birthday"
        type="date"
        :clearable="false"
        :placeholder="t('errors.pleaseInput', [])"
        :default-value="new Date(1999, 12, 31)"
        value-format="YYYY-MM-DD"
        style="width: 100%"
      />
    </el-form-item>

    <el-form-item
      :label="`${t('users.buyerAddress')} ${t('users.buyerAddressHelper')}`"
      prop="iso_province"
    >
      <el-select
        v-model="formData.iso_province"
        :placeholder="t('errors.pleaseSelect', [t('users.province')])"
        filterable
        style="width: 100%"
        @change="handleIsoProvince"
      >
        <el-option
          v-for="item in isoStateRef.provinceList"
          :key="item.iso"
          :label="`${item.name} (${item.name_en})`"
          :value="item.iso"
        />
      </el-select>
    </el-form-item>
    <el-form-item prop="iso_city">
      <el-select
        v-model="formData.iso_city"
        :placeholder="t('errors.pleaseSelect', [t('users.city')])"
        :disabled="!cityList.length"
        filterable
        style="width: 100%"
        @change="handleIsoCity"
      >
        <el-option
          v-for="item in cityList"
          :key="item.iso"
          :label="`${item.name} (${item.name_en})`"
          :value="item.iso"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      v-if="!!regionList.length"
      prop="iso_region"
    >
      <el-select
        v-model="formData.iso_region"
        :placeholder="t('errors.pleaseSelect', [t('users.region')])"
        filterable
        style="width: 100%"
        @change="handleIsoRegion"
      >
        <el-option
          v-for="item in regionList"
          :key="item.iso"
          :label="`${item.name} (${item.name_en})`"
          :value="item.iso"
        />
      </el-select>
    </el-form-item>

    <el-form-item prop="address">
      <el-input
        v-model="formData.address"
        :placeholder="`${t('users.address')} (${t('users.buyerAddressDesc')})`"
        maxlength="100"
      />
    </el-form-item>

    <el-form-item>
      <el-input
        v-model="formData.postcode"
        :placeholder="t('users.postcode')"
        :disabled="true"
      />
    </el-form-item>
  </div>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted } from "vue"
import { useI18n } from "vue-i18n"
import { useVModel } from '@vueuse/core'
//   import { IBankAccountUserForm } from "@/interfaces"
//   import { IsoState, IsoData } from "@/composables"

const props = defineProps({
  modelValue: Object,
  isoState: Object,
})

// const props = withDefaults(defineProps<{ modelValue; useIso }>(), {})
const emit = defineEmits(["update:modelValue", "change:province", "change:city"])

const { t } = useI18n()

const cityList = computed(() =>
  isoParams.city
    ? Object.keys(isoParams.city).map((iso) => {
        return { ...isoParams.city[iso], iso }
      })
    : []
)
const regionList = computed(() =>
  isoParams.region
    ? Object.keys(isoParams.region).map((iso) => {
        return { ...isoParams.region[iso], iso }
      })
    : []
)

const formData = useVModel(props, "modelValue", emit)
const isoParams = reactive({
  countryMap: null,
  province: null,
  city: null,
  region: null,
})
const isoStateRef = ref()

const handleIsoProvince = (iso) => {
  formData.value.province = isoStateRef.value?.province[iso].name
  formData.value.iso_city = null
  formData.value.iso_region = null
  isoParams.city = isoStateRef.value?.province[iso].city
  // emit("change:province", iso)
}
const handleIsoCity = (iso) => {
  // console.log("handleIsoCity: ", isoParams.city[iso])
  isoParams.region = isoParams.city[iso].region
  formData.value.city = isoParams.city[iso].name
  formData.value.iso_region = null
  formData.value.postcode = isoParams.city[iso].postal
  // emit("change:city", iso)
}
const handleIsoRegion = (iso) => {
  // console.log("region: ", isoParams.region)
  if (iso in isoParams.region) {
    formData.value.region = isoParams.region[iso]?.name
  }
}

watch(
  () => props.isoState,
  (v) => {
    if (!v) {
      return
    }
    isoStateRef.value = v
    if (formData.value.iso_province) {
      isoParams.city = v.province[formData.value.iso_province].city
    }
    if (formData.value.iso_city && isoParams.city) {
      isoParams.region = isoParams.city[formData.value.iso_city].region
    }
  },
  { deep: true, immediate: true }
)

</script>

<style></style>
